import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../components/commonDesign/SydModal'
import RenameThreadForm from './form'

const RenameThreadDialog = React.forwardRef(function RenameThreadDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (thread) => setDialogState({
      open: true,
      processing: false,
      thread
    })
  }), [setDialogState])

  return (
    <SydModal
      title='Rename Thread'
      open={dialogState.open}
      onClose={close}
      size='sm'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <RenameThreadForm
            thread={dialogState.thread}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

RenameThreadDialog.propTypes = {
  onComplete: PropTypes.func
}

RenameThreadDialog.defaultProps = {
  onComplete: () => {}
}

export default RenameThreadDialog
